import { toHandlers as _toHandlers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = { class: "time" }
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, ":", -1)
const _hoisted_5 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_date_picker = _resolveComponent("v-date-picker")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["vue-calendar", _ctx.mode])
  }, [
    _createVNode(_component_v_date_picker, {
      locale: _ctx.locale,
      "available-dates": _ctx.availableDates,
      "from-date": _ctx.minDate,
      popover: { visibility: 'focus' },
      modelValue: _ctx.activeDate,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.activeDate) = $event)),
      is24hr: "",
      onDayclick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onDatePick()))
    }, {
      default: _withCtx(({ inputValue, inputEvents }) => [
        _createElementVNode("input", _mergeProps({ value: inputValue }, _toHandlers(inputEvents), { role: "textbox" }), null, 16, _hoisted_1),
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeDateHour) = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onHourPick())),
            role: "combobox"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOptionsHours, (option, index) => {
              return (_openBlock(), _createElementBlock("option", {
                key: index,
                value: option.value
              }, _toDisplayString(option.text), 9, _hoisted_3))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.activeDateHour]
          ]),
          _hoisted_4,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeDateMinute) = $event)),
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onMinutePick())),
            role: "combobox"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOptionsMinutes, (option, index) => {
              return (_openBlock(), _createElementBlock("option", {
                key: index,
                value: option.value
              }, _toDisplayString(option.text), 9, _hoisted_5))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.activeDateMinute]
          ])
        ])
      ]),
      _: 1
    }, 8, ["locale", "available-dates", "from-date", "modelValue"])
  ], 2))
}